// Bridge for reporting errors to observa from module-level code (the tRPC
// client, src/trpc.ts) that lives outside the React tree and so can't call
// useObserva(). ObservaWiring (_layout.tsx) registers the live client here once
// the provider mounts; reportError() forwards to it (and no-ops before then, or
// in local dev where there's no provider). Reusing the provider's client keeps
// the userId/session resolvers and breadcrumb buffer intact.
type ErrorReporter = {
  error: (input: {
    error: { name?: string; message?: string; stack?: string };
    context?: Record<string, unknown>;
  }) => unknown;
};

let reporter: ErrorReporter | null = null;

export function setObservaReporter(client: ErrorReporter | null): void {
  reporter = client;
}

export function reportError(
  err: unknown,
  context?: Record<string, unknown>,
): void {
  if (reporter === null) return;
  const e = err instanceof Error ? err : new Error(String(err));
  void reporter.error({
    error: { name: e.name, message: e.message, stack: e.stack },
    context,
  });
}
